<template>
    <div class="page-container">
        <div class="container-fluid">
            <!-- Navigation Breadcrumb -->
            <div class="page-navigation">
                <div class="breadcrumb-custom">
                    <router-link to="/">
                        <i class="fas fa-home"></i> Home
                    </router-link>
                    <span class="separator">/</span>
                    <router-link to="/attendance">Kehadiran</router-link>
                    <span class="separator">/</span>
                    <router-link :to="{ name: 'AttendanceSubject', params: { sr_id: $route.params.sr_id } }">Mata Kuliah</router-link>
                    <span class="separator">/</span>
                    <span>Detail</span>
                </div>
            </div>

            <!-- Page Header -->
            <div class="page-header">
                <h2 class="page-title">Detail Kehadiran</h2>
                <p class="page-subtitle">Rekod kehadiran harian mata kuliah</p>
            </div>

            <div class="row justify-content-center">
                <div class="col-12 col-lg-6">
                    
                    <!-- Attendance Table Card -->
                    <div class="detail-card">
                        <div class="detail-header">
                            <i class="fas fa-calendar-check"></i>
                            <h5>Senarai Kehadiran</h5>
                        </div>
                        
                        <div class="detail-body">
                            <div class="table-responsive">
                                <table class="attendance-table">
                                    <thead>
                                        <tr>
                                            <th>Tarikh</th>
                                            <th>Hari</th>
                                            <th>Kehadiran</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in report" :key="index">
                                            <td>{{ item.teaching_date | thaiDate }} {{ item.start_time | rumiTime }}</td>
                                            <td>{{ item.teaching_day | dayOfWeek }}</td>
                                            <td>
                                                <span class="attendance-badge" :class="getStatusClass(item.status)">
                                                    <i :class="getStatusIcon(item.status)"></i>
                                                    {{ getStatusText(item.status) }}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr v-if="report.length === 0">
                                            <td colspan="3" class="empty-row">
                                                <i class="fas fa-inbox"></i>
                                                Tiada rekod kehadiran dijumpai
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '@/services/BackendService'
    export default {
        mounted(){
            this.retreiveDetail()
        },
        data(){
            return{
                s_id: localStorage.getItem("attendance_detail_s_id"),
                report: []
            }
        },
        methods:{
            getStatusClass(status) {
                if (status == null) return 'warning'
                if (status == 1) return 'success'
                if (status == 3) return 'danger'
                return 'warning'
            },
            getStatusIcon(status) {
                if (status == null) return 'fas fa-question-circle'
                if (status == 1) return 'fas fa-check-circle'
                if (status == 3) return 'fas fa-times-circle'
                return 'fas fa-exclamation-circle'
            },
            getStatusText(status) {
                if (status == null) return 'Tidak Ada Catatan'
                if (status == 1) return 'Hadir'
                if (status == 3) return 'Ghaib'
                return 'Uzur'
            },
            retreiveDetail(){
                this.$Progress.start()
                let s_id = this.s_id
                http.get(`learning/retriveAttendanceDetail/${s_id}`)
                    .then(response => {
                        this.report = response.data.report
                        this.$Progress.finish()
                    })
                    .catch(error => {
                        if(error.response.status == 401 || error.response.status == 419){
                            this.$store.dispatch("authentication/cencelAuthen")
                        }
                        this.$Progress.fail()
                    })
            }
        }
    }
</script>

<style scoped>
.detail-card {
    background: var(--bg-white);
    border-radius: var(--border-radius);
    box-shadow: var(--shadow-md);
    overflow: hidden;
}

.detail-header {
    background: var(--primary-gradient);
    color: var(--text-white);
    padding: 16px 20px;
    display: flex;
    align-items: center;
    gap: 12px;
}

.detail-header i {
    font-size: 1.2rem;
}

.detail-header h5 {
    margin: 0;
    font-weight: 600;
}

.detail-body {
    padding: 0;
}

.attendance-table {
    width: 100%;
    border-collapse: collapse;
}

.attendance-table thead {
    background: #f8f9fa;
}

.attendance-table th {
    padding: 14px 16px;
    text-align: left;
    font-weight: 600;
    color: var(--text-primary);
    font-size: 0.9rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 2px solid #e9ecef;
}

.attendance-table td {
    padding: 14px 16px;
    border-bottom: 1px solid #f0f0f0;
    color: var(--text-secondary);
    font-size: 0.95rem;
}

.attendance-table tbody tr:hover {
    background: #f8f9fa;
}

.attendance-table tbody tr:last-child td {
    border-bottom: none;
}

.attendance-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 14px;
    border-radius: 20px;
    font-weight: 500;
    font-size: 0.85rem;
}

.attendance-badge.success {
    background: rgba(71, 192, 122, 0.15);
    color: var(--primary-color);
}

.attendance-badge.danger {
    background: rgba(220, 53, 69, 0.15);
    color: #dc3545;
}

.attendance-badge.warning {
    background: rgba(255, 193, 7, 0.15);
    color: #b8860b;
}

.empty-row {
    text-align: center;
    padding: 40px 20px !important;
    color: var(--text-secondary);
}

.empty-row i {
    display: block;
    font-size: 2rem;
    margin-bottom: 12px;
    opacity: 0.4;
}

@media (max-width: 576px) {
    .attendance-table th,
    .attendance-table td {
        padding: 12px;
        font-size: 0.85rem;
    }
    
    .attendance-badge {
        padding: 4px 10px;
        font-size: 0.8rem;
    }
}
</style>